// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-title img {
    width: 100%;
}

a {
    color: #DA512D;
    text-decoration: none;
}

.company-title p {
    margin: 0;
}

.company-title .phone {
    color: #DA512D;
}

.logoPreview {
    width: 180px;
    height: 180px;
    border: 1px solid #ccc;
    border-radius: 5px;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
}

.logoPreview img {
    width: inherit;
    height: auto;
}

.logoFileBtn {
    position: relative;
    bottom: 15px;
    color: #98bcd5;
    font-size: 16px;
}

.mat-form-field {
    width: 100%;
}

form small.error {
    position: relative;
    top: -24px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJyb2tlci1kZXRhaWwuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLFdBQVc7QUFDZjs7QUFFQTtJQUNJLGNBQWM7SUFDZCxxQkFBcUI7QUFDekI7O0FBRUE7SUFDSSxTQUFTO0FBQ2I7O0FBRUE7SUFDSSxjQUFjO0FBQ2xCOztBQUVBO0lBQ0ksWUFBWTtJQUNaLGFBQWE7SUFDYixzQkFBc0I7SUFDdEIsa0JBQWtCO0lBQ2xCLG1CQUFtQjtJQUNuQixzQkFBc0I7SUFDdEIsa0JBQWtCO0FBQ3RCOztBQUVBO0lBQ0ksY0FBYztJQUNkLFlBQVk7QUFDaEI7O0FBRUE7SUFDSSxrQkFBa0I7SUFDbEIsWUFBWTtJQUNaLGNBQWM7SUFDZCxlQUFlO0FBQ25COztBQUVBO0lBQ0ksV0FBVztBQUNmOztBQUVBO0lBQ0ksa0JBQWtCO0lBQ2xCLFVBQVU7QUFDZCIsImZpbGUiOiJicm9rZXItZGV0YWlsLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuY29tcGFueS10aXRsZSBpbWcge1xuICAgIHdpZHRoOiAxMDAlO1xufVxuXG5hIHtcbiAgICBjb2xvcjogI0RBNTEyRDtcbiAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG59XG5cbi5jb21wYW55LXRpdGxlIHAge1xuICAgIG1hcmdpbjogMDtcbn1cblxuLmNvbXBhbnktdGl0bGUgLnBob25lIHtcbiAgICBjb2xvcjogI0RBNTEyRDtcbn1cblxuLmxvZ29QcmV2aWV3IHtcbiAgICB3aWR0aDogMTgwcHg7XG4gICAgaGVpZ2h0OiAxODBweDtcbiAgICBib3JkZXI6IDFweCBzb2xpZCAjY2NjO1xuICAgIGJvcmRlci1yYWRpdXM6IDVweDtcbiAgICBkaXNwbGF5OiB0YWJsZS1jZWxsO1xuICAgIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xufVxuXG4ubG9nb1ByZXZpZXcgaW1nIHtcbiAgICB3aWR0aDogaW5oZXJpdDtcbiAgICBoZWlnaHQ6IGF1dG87XG59XG5cbi5sb2dvRmlsZUJ0biB7XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgIGJvdHRvbTogMTVweDtcbiAgICBjb2xvcjogIzk4YmNkNTtcbiAgICBmb250LXNpemU6IDE2cHg7XG59XG5cbi5tYXQtZm9ybS1maWVsZCB7XG4gICAgd2lkdGg6IDEwMCU7XG59XG5cbmZvcm0gc21hbGwuZXJyb3Ige1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICB0b3A6IC0yNHB4O1xufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/secure/broker-detail/broker-detail.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA,wiDAAwiD","sourcesContent":[".company-title img {\n    width: 100%;\n}\n\na {\n    color: #DA512D;\n    text-decoration: none;\n}\n\n.company-title p {\n    margin: 0;\n}\n\n.company-title .phone {\n    color: #DA512D;\n}\n\n.logoPreview {\n    width: 180px;\n    height: 180px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n}\n\n.logoPreview img {\n    width: inherit;\n    height: auto;\n}\n\n.logoFileBtn {\n    position: relative;\n    bottom: 15px;\n    color: #98bcd5;\n    font-size: 16px;\n}\n\n.mat-form-field {\n    width: 100%;\n}\n\nform small.error {\n    position: relative;\n    top: -24px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
